@if (sender(); as sender) {
	<ctx-avatar size="l" [user]="sender" [tuiHint]="sender | userName" />
} @else {
	<ctx-avatar
		size="l"
		icon="@tui.bot"
		[tuiHint]="'notification.system-notification' | transloco"
	/>
}

<div class="notification-row__information">
	<p class="m-0">
		<tui-icon [icon]="icon()" />
		<span
			[innerHtml]="
				'notification.' + notification().type
					| transloco: notification().args
			"
		></span>
	</p>
	<small>{{ notification().createdAt | relativeTime }}</small>
</div>

<div class="notification-row__actions">
	<ng-content />
</div>
